module.exports = __webpack_public_path__ + "img/qiwei-icon.56c05694.png";